import { apiFactory } from "../api_factory";
export const facilitiesApi = apiFactory({
  path: "/api/v4/facilities"
});
